export default __webpack_public_path__ + "static/media/search.7c5060f3.svg";